import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getParticipantStats, type LabStatsQueryParams } from '@/services/classLabPlatformService';

export interface ParticipantStatsResponse {
    classData: {
        id: number;
        minPassingScore: number;
        class_name: string;
        customer_name: string;
        organizationId: number;
    };
    stats: {
        total_participants: number;
        pass_count: number;
        total_play_count: number;
        total_play_time: number;
    };
    userList: Array<{
        user_id: number;
        user_email: string;
        user_name: string;
        affiliation: string;
        job_title: string;
        play_count: number;
        total_play_time: number;
        participated_scenario_count: number;
        completed_scenario_count: number;
        highest_score: number | null;
        status: string;
    }>;
    total_count: number;
    total_page: number;
}

export function useParticipantStats(
    classId: number,
    params?: LabStatsQueryParams,
    options?: Omit<UseQueryOptions<ParticipantStatsResponse>, 'queryKey' | 'queryFn'>
) {
    return useQuery<ParticipantStatsResponse>({
        queryKey: ['participantStats', classId, params],
        queryFn: async () => {
            const response = await getParticipantStats(classId, params);
            return response as ParticipantStatsResponse;
        },
        ...options,
    });
}
